module.exports = __webpack_public_path__ + "public/hws/images/upgrade.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/upgrade.jpg
// module id = 345
// module chunks = 0